(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("dayjs"), require("react"), require("react-dom"));
	else if(typeof define === 'function' && define.amd)
		define(["dayjs", "react", "react-dom"], factory);
	else if(typeof exports === 'object')
		exports["bonree-design-antd"] = factory(require("dayjs"), require("react"), require("react-dom"));
	else
		root["bonree-design-antd"] = factory(root["dayjs"], root["React"], root["ReactDOM"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE_dayjs__, __WEBPACK_EXTERNAL_MODULE_react__, __WEBPACK_EXTERNAL_MODULE_react_dom__) {
return 